import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Immobile, Profilo } from '../../../../models';

@Component({
  selector: 'app-dialog-profilo-cancellazione-logica',
  templateUrl: './dialog-profilo-cancellazione-logica.component.html',
  styleUrls: ['./dialog-profilo-cancellazione-logica.component.css']
})
export class DialogProfiloCancellazioneLogica implements OnInit {
  profilo: Profilo;

  constructor(public dialogRef: MatDialogRef<DialogProfiloCancellazioneLogica>,
    @Inject(MAT_DIALOG_DATA) public data: Profilo) 
  {
    this.profilo = data;
  }

  ngOnInit() {}

  si(){
    this.dialogRef.close(true);
  }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-profilo-cancellazione-logica/dialog-profilo-cancellazione-logica.component.ts